import { render } from "./InputTextBorderless.vue?vue&type=template&id=1b22b1d7&scoped=true"
import script from "./InputTextBorderless.vue?vue&type=script&lang=js"
export * from "./InputTextBorderless.vue?vue&type=script&lang=js"

import "./InputTextBorderless.vue?vue&type=style&index=0&id=1b22b1d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b22b1d7"]])

export default __exports__